import PropTypes from 'prop-types';
import passengerShape from './passenger';

export default PropTypes.shape({
  coach: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  inventoryClass: PropTypes.string.isRequired,
  passenger: passengerShape
});
